// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1M8TU","rightAdornment":"Header_rightAdornment__ZEbmG"};